import {catchUnhandledDataGridActions} from '@dms/shared';

import {openBulkOperationActionDialog, type BulkOperationActionCallback} from 'features/eag-grid';

import {BusinessCaseReassignBulkForm} from '../pages/BusinessCaseList/components/BusinessCaseReassignBulkForm/BusinessCaseReassignBulkForm';

export const businessCaseBulkOperationActionCallback: BulkOperationActionCallback = (action) => {
  if (action.actionKey === 'REASSIGN') {
    return openBulkOperationActionDialog(action, <BusinessCaseReassignBulkForm action={action} />);
  }
  catchUnhandledDataGridActions(action.actionKey);
};
